import { Link, Typography } from '@mui/material'
import { Icons } from 'utoniq-ui'

import { PreSaleType } from '@/clients/utoniq-core/schema'
import { BaseLayout, Head } from '@/components/layouts'
import { ArtistThemeProvider } from '@/components/styles'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'
import { getHelpUrl } from '@/lib/helpUrl'

import {
  FirstComeFirstServedCreateForm,
  FirstComeFirstServedCreateValues,
} from './FirstComeFirstServedCreateForm'
import { LotteryCreateForm, LotteryCreateValues } from './LotteryCreateForm'

export * from './fragments'

export type State = {
  artistId: string
  preSaleType?: string
  submitting: boolean
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onSubmit: (
    values: LotteryCreateValues | FirstComeFirstServedCreateValues
  ) => Promise<void>
}

export const ConsolePreSaleCreateTemplate: Template<State, Action> = ({
  state,
  onSubmit,
}) => {
  const { t } = useTranslation('consolePreSaleCreate')
  const { routerNames, generatePath, routerPages, router } =
    useRouter<{ preSaleType?: PreSaleType; eventId: string }>()

  return (
    <ArtistThemeProvider artistId={state.artistId}>
      <Head title={routerNames.ConsolePreSaleCreate} />
      <BaseLayout
        header={{
          title: t('title'),
          defaultBackPage: generatePath(
            routerPages.ConsoleShokufesEventDetail,
            {
              eventId: router.query.eventId ?? '#',
            }
          ),
          back: true,
        }}
        margin
      >
        <Typography variant="h3" sx={{ py: 3, mt: 5 }}>
          {t(`${state.preSaleType}Title`)}
        </Typography>
        <Link
          component="a"
          target="_blank"
          href={getHelpUrl('preSale')}
          variant="caption"
          sx={{ alignItems: 'center', display: 'flex' }}
        >
          {t(`${state.preSaleType}Help`)}
          <Icons.Help fontSize="xSmall" color="inherit" sx={{ ml: 1 }} />
        </Link>
        {state.preSaleType === PreSaleType.Lottery ? (
          <LotteryCreateForm
            submitting={state.submitting}
            onSubmit={onSubmit}
          />
        ) : (
          <FirstComeFirstServedCreateForm
            submitting={state.submitting}
            onSubmit={onSubmit}
          />
        )}
      </BaseLayout>
    </ArtistThemeProvider>
  )
}
